import useSWR from "swr";
import ManagedDnsZonesService from "services/ManagedDnsZonesService";

const fetcher = () => ManagedDnsZonesService.getAll().then((res) => res.data);

const useManagedDnsZonesSwr = () => {
    const { data: zones = [], error, isLoading, mutate } = useSWR(
        "managed_dns_zones",
        fetcher
    );

    return {
        zones,
        error,
        isLoading,
        mutate,
    };
};

export default useManagedDnsZonesSwr;
